import './infoSection.scss';

interface InfoSectionProps {
  title: string;
  children: React.ReactNode;
}

const InfoSection: React.FC<InfoSectionProps> = ({ title, children }: InfoSectionProps) => {

  return (
    <div className='info-content'>
        <h1 className='info-title'>
          {title}
        </h1>
        {children}
      </div>
  );
};

export default InfoSection;